import React from "react";
import { IGongBallJituHistoryType } from "@/types/GameHistoryTypes";
import Nnary from "@/modules/Nnary";
import nary from "@/modules/nary";
import { assetImg } from "@/modules/moduleImporter";
import { isNullOrEmpty } from "@/modules/commonMobile";
import "@/styles/machine_game_statistics.scss";

interface IProps {
    history: IGongBallJituHistoryType[];
}

export default class M33 extends React.Component<IProps> {
    render() {
        const { history } = this.props;

        //Initialise output
        const output = {};
        const outputKeys = [...Nnary(1, 9), 0, "J", "Q", "K"];
        outputKeys.forEach(ball => {
            output[ball] = 0;
        });

        //Process history object
        const total = history.length * 3;
        history.forEach(item => {
            item.ball.split(",").forEach(card => {
                output[card]++;
            })
        });

        return (
            <div className="game-statistics machine-game-statistics m33-statistics">
                {
                    nary(7).map((_num, idx) =>
                        <div className="row" key={"m33_gs_" + (idx * 2)}>
                            <div>
                                {assetImg("gb_history", outputKeys[idx * 2] + "")}
                                <div>
                                    { Math.round(output[outputKeys[idx * 2]] / total * 100) } %
                                </div>
                            </div>

                        {
                            !isNullOrEmpty(outputKeys[idx * 2 + 1]) &&
                            <div>
                                {assetImg("gb_history", outputKeys[idx * 2 + 1] + "")}
                                <div>
                                    { Math.round(output[outputKeys[idx * 2 + 1]] / total * 100) } %
                                </div>
                            </div>
                        }
                        </div>
                    )
                }
            </div>
        )
    }
}